/**
 * Click Payment Integration Utilities
 * 
 * Note: Click URL generation is handled server-side for security.
 */

/**
 * Check if Click is configured
 * Note: This checks if the backend function is available,
 * not if frontend has credentials (which it shouldn't)
 */
export function isClickConfigured(): boolean {
  // Click is configured if Supabase URL is available
  // The actual credentials check happens server-side
  return !!import.meta.env.VITE_SUPABASE_URL;
}

